module.exports = {
  "evaluation": {
    evaluationList: "心理测评",
    "personalEvaluation": "个人测评",
    "groupEvaluation": "团体测评",
    "evaluationName": "测评名称",
    "evaluationType": "测评类型",
    "evaluationProgress": "测评进度",
    evaluationScaleList: "量表列表",
    "previousQuestion": "上一题",
    "previousQuestionHint": "前面没有题目了",
    "nextQuestion": "下一题",
    "nextQuestionHint": "已经是最后一题了",
    "viewEvaluationRecords": "查看测评记录",
    "evaluationTime": "测评时间",
    "secondaryEvaluationHint": "您已经完成了当前量表测评，请在测评列表中继续完成剩下的量表测评。",
    "viewReport": "查看报告",
    "evaluationWriteSure": "测评填写完成",
  },
}



// WEBPACK FOOTER //
// ./src/i18n/evaluation/en.js